export default __webpack_public_path__ + "static/illustrationJourneyBackground-49d892c8affbdf093216dac3d48498a6.svg";